<template>
    <el-container style="width:100%;">
        <el-header>
            <el-row class="paddingTop10 marginBottom20">
                <el-col>
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnQuery">{{ $t('pgCommon.REFRESH') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAdd">{{ $t('common.ADD') }}</td-button>
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :permissions="permissionsQuery"
                :hasMutiSelect="false"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-MqInfo
                v-if="dialogMqVisible"
                :isAddData="isAddData"
                :editItem="editItem"
                :dialogMqVisible="dialogMqVisible"
                :title="title"
                @queryList="queryList"
                @mqCasDialogClose="mqCasDialogClose"
            ></dialog-MqInfo>
        </el-main>
    </el-container>
</template>
<script>
import mqCasApi from './assets/api.js';
import dialogMqCasCade from './components/dialogMqCasCade.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-MqInfo': dialogMqCasCade
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        //this.queryList();
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['mqcascade:view'],
            permissionsAdd: ['mqcascade:add'],
            title: '',
            editItem: '', // 要编辑的数据
            isAddData: true, // 是否为添加数据
            dialogMqVisible: false,
            formMqCas: {},
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            tableLoading: false, // 表格是否为加载状态
            columns: [
                {
                    prop: 'sFromChannel',
                    label: 'common.FROM_CHANNEL',
                    align: 'center'
                },
                {
                    prop: 'sToChannel',
                    label: 'common.TO_CHANNEL',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['mqcascade:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['mqcascade:del'] },
                                    on: {
                                        click: () => {
                                            this.delete(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 加载mq级联列表信息
        queryList() {
            this.tableLoading = true;
            let param = {
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            mqCasApi.getMqChannerCascadeList(JSON.stringify(param), response => {
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerCascadeList', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerCascadeList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
                this.tableLoading = false;
            });
        },
        // 查询
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        // 编辑
        btnExit(row) {
            this.isAddData = false;
            this.editItem = row;
            this.title = 'common.EDIT'; // 标题
            this.dialogMqVisible = true;
        },
        // 删除
        delete(row) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sFromChannelId: row.sFromChannelId,
                        sCascadeId: row.sCascadeId
                    };
                    mqCasApi.deleteMqChannerCascade(JSON.stringify(param), response => {
                        if (response.status === undefined) {
                            return;
                        }
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                            this.$log.error('/mqCascadeManager/deleteMqChannerCascade', response);
                            return;
                        }
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/mqCascadeManager/deleteMqChannerCascade', response.data.statusMessage);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.queryList();
                    });
                })
                .catch(() => {});
        },
        // 添加
        btnAdd() {
            this.isAddData = true;
            this.title = 'common.ADD'; // 标题
            this.dialogMqVisible = true;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 关闭dialog
        mqCasDialogClose() {
            this.dialogMqVisible = false;
        }
    }
};
</script>
<style></style>
